export default "__VITE_ASSET__C8ayZ2Hy__"